// Keep in sync with backend/error_tags.py. Adding/removing/renaming a tag here
// without updating the backend will cause persistence to silently drop or break.

export const ERROR_TAGS = {
  conceptual_gap: "Didn't know the concept",
  misread: "Misread question or stem",
  careless: "Knew it, careless mistake",
  timing: "Rushed or ran out of time",
  formula_recall: "Knew concept, blanked on formula",
  process_of_elimination: "Narrowed to two, picked wrong",
  trap_answer: "Fell for distractor / trap answer",
} as const;

export type ErrorTag = keyof typeof ERROR_TAGS;

export const ERROR_TAG_KEYS: ErrorTag[] = Object.keys(ERROR_TAGS) as ErrorTag[];

// Compact labels for chips/badges
export const ERROR_TAG_SHORT: Record<ErrorTag, string> = {
  conceptual_gap: "Conceptual",
  misread: "Misread",
  careless: "Careless",
  timing: "Timing",
  formula_recall: "Formula",
  process_of_elimination: "POE",
  trap_answer: "Trap",
};
